import RedirectContainer from "../../components/RedirectContainer";
import SidebarPanelNavigation from "../../components/SidebarPanelNavigation";
import {
    Container,
    Row,
    Col,
    Button,
    Table,
    Form,
    Modal
} from "react-bootstrap";
import { useState, useEffect } from "react";
import { MdDelete, MdEdit } from "react-icons/md";
import LoadingIndicator from "../../components/LoadingIndicator";
import useNotification from "../../contexts/notification";
import { FaLink } from "react-icons/fa";
import {
    getAllGruposAdmin,
    deleteGrupo,
    exportGruposToGoogleSheets,
    importGruposFromFile,
    searchGrupo,
    createGrupo,
    updateGrupo
} from "../../services/api";
export default function GruposAdmin({ tipo, titulo }) {
    const [grupos, setGrupos] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedIds, setSelectedIds] = useState([]);
    const [idInput, setIdInput] = useState("");
    const [urlInput, setUrlInput] = useState("");
    const [query, setQuery] = useState("");
    const [showEditModal, setShowEditModal] = useState(false);
    const [editData, setEditData] = useState({ id: null, nome: "", url: "" });
    const { setMessage } = useNotification();
    console.log(tipo);
    const refresh = () => {
        getAllGruposAdmin(tipo).then(
            (data) => {
                setGrupos(data.grupos || []);
                setIsLoading(false);
            },
            () =>
                setMessage({
                    error: true,
                    content: "Erro ao carregar grupos",
                })
        );
    };

    useEffect(() => {
        refresh();
    }, []);

    const handleSelect = (id) => {
        setSelectedIds((prev) =>
            prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
        );
    };

    const handleMassEdit = () => {
        exportGruposToGoogleSheets(selectedIds);
    };

    const handleImport = (e) => {
        const file = e.target.files[0];
        if (file) {
            importGruposFromFile(file).then(() => {
                setMessage({ error: false, content: "Importação concluída" });
                refresh();
            });
        }
    };

    const handleSearch = (e) => {
        e.preventDefault();
        if (query.trim() === "") {
            refresh();
        } else {
            searchGrupo(query).then(
                (data) => {
                    setGrupos(data.grupos || []);
                },
                () =>
                    setMessage({
                        error: true,
                        content: "Erro ao buscar grupos",
                    })
            );
        }
    };

    const handleCadastrar = () => {
        if (!idInput.trim() || !urlInput.trim()) {
            setMessage({
                error: true,
                content: "Preencha ID e Link antes de cadastrar",
            });
            return;
        }

        createGrupo({
            nome: idInput,
            url: urlInput,
            tipo: tipo
        }).then(
            () => {
                setMessage({
                    error: false,
                    content: "Grupo cadastrado com sucesso",
                });
                setIdInput("");
                setUrlInput("");
                refresh();
            },
            () => {
                setMessage({
                    error: true,
                    content: "Erro ao cadastrar grupo",
                });
            }
        );
    };

    const handleEditClick = () => {
        const grupo = grupos.find(g => g.id === selectedIds[0]);
        if (grupo) {
            setEditData({ id: grupo.id, nome: grupo.nome, url: grupo.url });
            setShowEditModal(true);
        }
    };

    const handleUpdateGrupo = () => {
        if (!editData.nome.trim() || !editData.url.trim()) {
            setMessage({
                error: true,
                content: "Preencha todos os campos antes de salvar",
            });
            return;
        }

        updateGrupo(editData.id, {
            nome: editData.nome,
            url: editData.url,
            tipo: tipo
        }).then(() => {
            setMessage({
                error: false,
                content: "Grupo atualizado com sucesso",
            });
            setShowEditModal(false);
            setSelectedIds([]);
            refresh();
        }).catch(() => {
            setMessage({
                error: true,
                content: "Erro ao atualizar grupo",
            });
        });
    };

    return (
        <RedirectContainer role="admin">
            <Container fluid>
                <SidebarPanelNavigation isAdmin />
                <div className="content-panel">
                    {isLoading && <LoadingIndicator />}
                    {!isLoading && (
                        <>
                            <h5 className="text-primary my-3 d-flex align-items-center">
                                <FaLink className="me-2" />
                                {titulo}
                            </h5>

                            <div className="d-flex align-items-center mb-3">
                                <span className="primary" style={{ color: '#0052B3', fontWeight: "bold", marginRight: "10px" }}>
                                    Link para divulgação:
                                </span>
                                <Button
                                    variant="outline-primary"
                                    size="sm"
                                    style={{
                                        borderRadius: "20px",
                                        fontWeight: "bold",
                                        padding: "4px 14px"
                                    }}
                                    onClick={() => {
                                        navigator.clipboard.writeText(`https://cacadores-de-ofertas.com/backend/public/entrar?tipo=${tipo}`);
                                        setMessage({
                                            error: false,
                                            content: "Link copiado para a área de transferência!"
                                        });
                                    }}
                                >
                                    Copiar Link
                                </Button>
                            </div>
                            <div
                                style={{
                                    border: "1px solid #ccc",
                                    padding: "15px",
                                    borderRadius: "4px",
                                    marginBottom: "20px",
                                }}
                            >
                                <Row className="align-items-center">
                                    <Col md={4} sm={12} className="mb-2">
                                        <Form.Control
                                            type="text"
                                            placeholder="Insira o ID"
                                            value={idInput}
                                            onChange={(e) => setIdInput(e.target.value)}
                                        />
                                    </Col>
                                    <Col md={6} sm={12} className="mb-2">
                                        <Form.Control
                                            type="text"
                                            placeholder="Insira o link"
                                            value={urlInput}
                                            onChange={(e) => setUrlInput(e.target.value)}
                                        />
                                    </Col>
                                    <Col md={2} sm={12} className="mb-2">
                                        <Button
                                            variant="primary"
                                            className="w-100"
                                            style={{
                                                borderRadius: "20px",
                                                padding: "6px 16px",
                                                fontWeight: "bold"
                                            }}

                                            onClick={handleCadastrar}
                                        >
                                            Cadastrar
                                        </Button>
                                    </Col>
                                </Row>
                            </div>

                            {/* Botões */}
                            {/* Botões de ação */}
                            <div className="mb-3 d-flex justify-content-between align-items-center flex-wrap">
                                <div className="d-flex flex-wrap align-items-center" style={{ gap: "10px" }}>
                                    <Button
                                        variant="warning"
                                        className="text-white mb-2"
                                        onClick={handleEditClick}
                                        disabled={selectedIds.length !== 1}
                                        style={{
                                            borderRadius: "20px",
                                            padding: "6px 16px",
                                            fontWeight: "bold"
                                        }}

                                    >
                                        <MdEdit /> Editar
                                    </Button>

                                    {selectedIds.length >= 1 && (
                                        <Button
                                            variant="danger"
                                            className="mb-2"
                                            style={{
                                                borderRadius: "20px",
                                                padding: "6px 16px",
                                                fontWeight: "bold"
                                            }}

                                            onClick={() => {
                                                if (window.confirm("Deseja excluir o(s) grupo(s) selecionado(s)?")) {
                                                    deleteGrupo(selectedIds).then(() => {
                                                        setMessage({
                                                            error: false,
                                                            content: "Grupo(s) excluído(s)",
                                                        });
                                                        setSelectedIds([]);
                                                        refresh();
                                                    });
                                                }
                                            }}
                                        >
                                            <MdDelete /> Excluir
                                        </Button>
                                    )}

                                    {/*selectedIds.length > 1 && (
                                    <Button
                                        variant="primary"
                                        className="mb-2"
                                        style={{
                                            borderRadius: "20px",
                                            padding: "6px 16px",
                                            fontWeight: "bold"
                                        }}

                                        onClick={handleMassEdit}
                                    >
                                        Edição em massa
                                    </Button>
                                    )*/}
                                </div>


                                {/* Botão Importar à direita */}
                                <label className="btn btn-primary mb-2" style={{
                                    borderRadius: "20px",
                                    padding: "6px 16px",
                                    fontWeight: "bold"
                                }}
                                >
                                    Importar
                                    <input
                                        type="file"
                                        accept=".xlsx,.xls,.csv"
                                        hidden
                                        onChange={handleImport}
                                    />
                                </label>
                            </div>



                            {/* Tabela */}
                            <Table striped bordered hover responsive size="sm">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>ID do grupo</th>
                                        <th>Link</th>
                                        <th>Cliques</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {grupos.length === 0 && (
                                        <tr>
                                            <td colSpan={4} className="text-center">
                                                Nenhum grupo encontrado
                                            </td>
                                        </tr>
                                    )}
                                    {grupos.map((grupo) => (
                                        <tr key={grupo.id}>
                                            <td>
                                                <Form.Check
                                                    type="checkbox"
                                                    checked={selectedIds.includes(grupo.id)}
                                                    onChange={() => handleSelect(grupo.id)}
                                                />
                                            </td>
                                            <td>{grupo.nome}</td>
                                            <td>
                                                <a href={grupo.url} target="_blank" rel="noreferrer">
                                                    {grupo.url}
                                                </a>
                                            </td>
                                            <td>{grupo.cliques}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </>
                    )}

                    {/* Modal de Edição */}
                    <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>Editar Grupo</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form>
                                <Form.Group>
                                    <Form.Label>ID do Grupo</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={editData.nome}
                                        onChange={(e) =>
                                            setEditData({ ...editData, nome: e.target.value })
                                        }
                                    />
                                </Form.Group>
                                <Form.Group className="mt-2">
                                    <Form.Label>Link</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={editData.url}
                                        onChange={(e) =>
                                            setEditData({ ...editData, url: e.target.value })
                                        }
                                    />
                                </Form.Group>
                            </Form>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setShowEditModal(false)}>
                                Cancelar
                            </Button>
                            <Button variant="primary" onClick={handleUpdateGrupo}>
                                Salvar Alterações
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </Container>
        </RedirectContainer>
    );
}
